import React from 'react';
import { boardMembers } from '../../config/imageAssets';
import { motion, Variants } from 'framer-motion';
import { BoardMember } from '../../types';
import { useTranslation } from 'react-i18next';

const cardVariants: Variants = {
  hidden: { 
    opacity: 0, 
    y: 50 
  },
  visible: (index: number) => ({
    opacity: 1, 
    y: 0,
    transition: {
      delay: index * 0.1,
      duration: 0.5,
      ease: "easeOut"
    }
  })
};

const BoardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center p-5">
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-10 text-center">{t('sections.board_title', 'Zarząd Chodzieskiego WOPR')}</h2>
      <div className="flex flex-wrap justify-center gap-5 max-w-[900px] mx-auto">
        {boardMembers.map((member: BoardMember, index: number) => (
          <motion.div 
            key={index} 
            className="rounded-lg w-[250px] overflow-hidden flex flex-col p-0 group bg-white shadow-sm"
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={cardVariants}
            whileHover={{ 
              y: -10,
              boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
              transition: { duration: 0.3 }
            }}
          >
            <img 
              src={member.src} 
              alt={member.alt} 
              className="w-full h-[200px] object-cover transition-transform duration-300 ease-in-out group-hover:scale-105" 
            />
            <div className="p-2.5 text-center mt-0">
              <p className="text-sm text-[#555] mb-1">{t(member.role)}</p>
              <p className="text-xl font-bold my-1">{member.name} {member.surname}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default BoardPage;
